import React from 'react'

class SSOToast extends React.Component {
    closeToast = () => {
        setTimeout(()=>{
            this.props.setShowToast(false)
        },10000)
    }
    render() {
        return(
            <div aria-live="polite" aria-atomic="true" className="position-relative" >
                <div className="toast-container p-3">
                    {this.props.showToast && (<div
                        className={`toast fade show position-fixed bg-${this.props.toastType} p-2`}
                        style={{ top: '16px', right: '16px', left: '13px', width:'98%' }}
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        data-delay="3000"
                        data-bs-animation="true"
                        onClick={()=>this.props.setShowToast(false)}
                    >
                        <div className="toast-body green text-center" style={{ fontSize: '1rem' }}>                           
                            <button type="button" className="btn-close position-absolute end-0 me-3" onClick={()=>this.props.setShowToast(false)}></button>
                            <img className="label_hover" src="/images/tick-green.svg"/>
                            {this.props.toastMessage}
                            {this.closeToast()}
                        </div>
                    </div>)
                    }
                </div>
            </div>
        )
    }
}

export default SSOToast;